import { NotificationManager } from 'react-notifications';
import axios from 'axios';
import { IQueryParams } from 'src/types';

import { IHint, IHintListData } from '../hints/types';

export const fetchHintsSitePageRequest = async ({ page, size, sort, ...body }: IQueryParams): Promise<IHintListData | null> => {
  try {
    const res = await axios.post('api/v1/payment/site-hints', body, { params: { page, size, sort } });
    return {
      ...res.data,
      content: res.data?.content?.map((hint: IHint) => ({ ...hint, payload: { ...hint.payload, hints: hint.payload.hints || [] } })),
    };
  } catch (error) {
    NotificationManager.error("Can't fetch site hints");
    return null;
  }
};

export const createHintSiteRequest = async ({ id, ...data }: Partial<IHint>): Promise<Partial<IHint>> => {
  const res = await axios.put(`api/v1/payment/site-hints`, data);
  return res.data;
};

export const updateHintSiteRequest = async ({ id, ...data }: Partial<IHint>): Promise<Partial<IHint>> => {
  const res = await axios.post(`api/v1/payment/site-hints/${id}`, data);
  return res.data;
};

export const deleteHintSiteRequest = async (id: number): Promise<Partial<IHint>> => {
  const res = await axios.delete(`api/v1/payment/site-hints/${id}`);
  return res.data;
};
